import { Expose } from 'class-transformer';

import { SnModel } from '@lib/common/models';

import { AxonDeviceLocationModel } from './axon-device-location.model';

export class AxonDeviceModel extends SnModel {
  @Expose()
  public deviceId: string;

  @Expose()
  public deviceType: string;

  @Expose()
  public deviceLocation: AxonDeviceLocationModel;

  @Expose()
  public serial: string;

  @Expose()
  public signalStrength: string;

  @Expose()
  public signalType: string;

  constructor(data: any = {}) {
    super();
    this.fromJSON(data);
  }
}
